export var BucketFilesMode;
(function (BucketFilesMode) {
    BucketFilesMode["BUCKET_FILES_MODE_POLLING"] = "POLLING";
    BucketFilesMode["BUCKET_FILES_MODE_EVENT_SQS"] = "EVENT_SQS";
    BucketFilesMode["BUCKET_FILES_MODE_EVENT_EVENTBRIDGE_SQS"] = "EVENT_EVENTBRIDGE_SQS";
    BucketFilesMode["BUCKET_FILES_MODE_EVENT_PUBSUB"] = "EVENT_PUBSUB";
    BucketFilesMode["BUCKET_FILES_MODE_EVENT_KAFKA"] = "EVENT_KAFKA";
})(BucketFilesMode || (BucketFilesMode = {}));
